/* eslint-disable prettier/prettier */
import DV360 from "./providers/dv360";
import TikTok from "./providers/tiktok";
import PML from "@/pixels/providers/PML";
import Adobe from "@/pixels/providers/adobe";
import { Facebook } from "@/pixels/providers/facebook";
import AlPrestamo from "@/pixels/providers/alprestamo";
import { GoogleSiteTag } from "@/pixels/providers/google";
import * as MUTATIONS from "@/config/constants/mutation-types";


const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      consulta: [
        "Adobe.consulta",
        "GoogleSiteTag.consulta",
        "Facebook.consulta",
        "TikTok.consulta",
        "DV360.consulta"
      ],
      oferta: [
        "Adobe.oferta",
        "GoogleSiteTag.oferta",
        "Facebook.oferta",
        "PML.oferta",
        "TikTok.oferta",
        "DV360.oferta"
      ],
      landingQR: [
        "Adobe.compruebaIdentidad",
        "GoogleSiteTag.compruebaIdentidad",
        "Facebook.compruebaIdentidad",
        "TikTok.landingQR"
      ],
      paso1: [
        "Adobe.paso1",
        "GoogleSiteTag.paso1",
        "Facebook.paso1",
        "TikTok.paso1"
      ],
      paso2: [
        "Adobe.paso2",
        "GoogleSiteTag.paso2",
        "Facebook.paso2",
        "TikTok.paso2"
      ],
      paso3: [
        "Adobe.paso3",
        "GoogleSiteTag.paso3",
        "Facebook.paso3",
        "PML.paso3",
        "TikTok.paso3"
      ],
      paso4: ["Adobe.paso4", "GoogleSiteTag.paso4", "Facebook.paso4", "TikTok.paso4"],
      loadingVeridas: [
        "Adobe.loadingVeridas",
        "GoogleSiteTag.loadingVeridas",
        "Facebook.loadingVeridas"
      ],
      biometriaOK: [
        "Adobe.biometriaOK",
        "GoogleSiteTag.biometriaOK",
        "Facebook.biometriaOK",
        "PML.biometriaOK"
      ],
      solicita: [
        "Adobe.solicita",
        "GoogleSiteTag.solicita",
        "Facebook.solicita"
      ],
      entrega: ["Adobe.entrega", "GoogleSiteTag.entrega", "Facebook.entrega", "TikTok.entrega"],
      resumen: ["Adobe.resumen", "GoogleSiteTag.resumen", "Facebook.resumen", "TikTok.resumen"],
      contratos: [
        "Adobe.contratos",
        "GoogleSiteTag.contratos",
        "Facebook.contratos",
        "TikTok.contratos"
      ],
      gracias: [
        "Adobe.gracias",
        "GoogleSiteTag.gracias",
        "Facebook.gracias",
        "AlPrestamo.gracias",
        "PML.gracias",
        "TikTok.gracias"
      ],
      usuario: ["Adobe.usuario", "GoogleSiteTag.usuario", "Facebook.usuario"],
      celular: ["Adobe.celular", "GoogleSiteTag.celular", "Facebook.celular"],
      final: ["Adobe.final", "GoogleSiteTag.final", "Facebook.final"],
      continuaSucursal: [
        "Adobe.continuaSucursal",
        "GoogleSiteTag.continuaSucursal",
        "Facebook.continuaSucursal"
      ],
      mensajeVeridas: ["Adobe.mensajeVeridas"],
      asesoramiento: ["Adobe.asesoramiento"],
      contacto: ["Adobe.contacto"],
      graciasPH: ["Adobe.graciasPH"]
    },
    [MUTATIONS.ON_INICIAR_SOLICITUD]: ["AlPrestamo.offered"],
    [MUTATIONS.ADOBE_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ADOBE_APPSTARTED]: ["Adobe.appStartedClick"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: ["Adobe.appOnClickStart"],
    [MUTATIONS.ADOBE_ERROR]: [
      "Adobe.errorPage",
      "GoogleSiteTag.errorPage",
      "Facebook.errorPage"
    ],
    [MUTATIONS.ADOBE_HIPOTECARIO_PAGE_VISIT]: ["Adobe.hipotecarioPageVisit"],
    [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_2]: ["Adobe.calculadoraValorStep2"],
    [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_3]: ["Adobe.calculadoraValorStep3"],
    [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_4]: ["Adobe.calculadoraValorStep4"],
    [MUTATIONS.ADOBE_CALCULADORA_VALOR_STEP_5]: ["Adobe.calculadoraValorStep5"]
  },
  providers: {
    Adobe,
    GoogleSiteTag,
    Facebook,
    AlPrestamo,
    PML,
    TikTok,
    DV360
  }
};

export default pixelDb;
